export const BodyC = ({children}) => {
  return (
    <body
      className="menu-sub-hidden show-spinner right-menu"
      id="app-container"
    >{children}</body>
  );
};
